import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PayoutCancelReasonEditor from './modal';

@modal(
  {
    className: 'payout-cancel-reason-editor-modal',
  },
  true,
)
class PayoutCancelEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, id } = this.props;

    return (
      <div className="payout-cancel-reason-editor">
        <div className="payout-cancel-reason-editor__header">
          {t(`cms.referral.payout.cancel_reason.editor.title`)}
          <CloseOutlined
            className="payout-cancel-reason-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <PayoutCancelReasonEditor
          bookingId={id}
          bookingJourney={this.props.bookingJourney}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

PayoutCancelEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

PayoutCancelEditorContainer.defaultProps = {
  t: () => {},
  id: '',
  handleCloseModal: () => {},
};

export default PayoutCancelEditorContainer;
